{#if product}
  {#if feature('price_changes')}
    <span class="product-status-tags" aria-label="Artikel-Badges">
      {#each badges as badge}
        <Tag type={badge.type} size="sm">
          {#if badge.tooltip}
            <TooltipDefinition tooltipText={badge.tooltip}>{badge.label}</TooltipDefinition>
          {:else}
            {badge.label}
          {/if}
        </Tag>
      {/each}
    </span>
  {:else if product.non_doc}
    <Tag type="purple" size="sm">
      <TooltipDefinition tooltipText="Kein Doku-Artikel">KDA</TooltipDefinition>
    </Tag>
  {/if}
{/if}

<script lang="ts">
  import { Tag, TooltipDefinition } from 'carbon-components-svelte'
  import type { TagProps } from 'carbon-components-svelte/types/Tag/Tag.svelte'
  import type { Product } from '../models'
  import { feature } from '../query'

  export let product: Product

  type Badge = {
    label: string
    type: TagProps['type']
    tooltip?: string
  }

  const kindBadges: Record<string, Badge> = {
    standard: { label: 'Standard', type: 'blue' },
    virtual: { label: 'Virtuell', type: 'warm-gray' },
    boxed: { label: 'Böxli', type: 'blue' },
    assembly: { label: 'Konfektion', type: 'blue' },
    assortment: { label: 'Sortiment', type: 'blue' },
    abstract: { label: 'Abstrakt', type: 'blue' },
  }

  const visibilityBadges: Record<string, Badge> = {
    program: { label: 'PA', tooltip: 'Programm-Artikel (PA)', type: 'blue' },
    third_party: { label: 'BES', tooltip: 'Auf Bestellung (BES)', type: 'gray' },
    internal: { label: 'INT', tooltip: 'Intern (INT)', type: 'cyan' },
  }

  $: badges = [
    kindBadges[product?.kind],
    visibilityBadges[product?.visibility],
    product?.discontinued && { label: 'APG', tooltip: 'Aus dem Programm gestrichen', type: 'red' },
    product?.out_of_stock && { label: 'NML', tooltip: 'Nicht mehr lieferbar', type: 'red' },
  ].filter(Boolean) as Badge[]
</script>

<style>
  .product-status-tags {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    align-items: center;
  }

  :global(.product-status-tags .bx--tag) {
    margin: 0;
  }
</style>
